import strings from "../../localization";
/*
  common utility functions can be added under utils folder
  for example time formatting ect
*/
type StringsType = typeof strings.en;

/** Canonical key for FPL week types — matches DB format (e.g. "FPL Viikko 3"). */
export const canonicalMatchTypeKey = (value: string): string => {
  const trimmed = value.trim();
  const week = /^FPL\s+Viikko\s+(\d+)$/i.exec(trimmed);
  if (week) return `FPL Viikko ${week[1]}`;
  return trimmed;
};

export const getMatchTypeLocalized = (value: string, strings: StringsType): string => {
  return canonicalMatchTypeKey(value).replace(/viikko/gi, strings.NEWS.MATCH);
};

export const getRequestData = async <T>(response: Response): Promise<T> => {
  return (await response.json()) as T;
};
